import { WHATSAPP } from './contacto';

// Conversational flows for GUIA
// isResult: true → muestra ResultExtras debajo del mensaje
// navTo: ruta a la que navegar cuando el usuario hace click en el CTA principal
// skippable: true → el input acepta envío vacío ("Continuar sin decirlo")
// options[].id → identificador de la opción para la medición (evento `respuesta`); nunca el texto.


export const FLOWS = {

  // ── PASO 1: pregunta principal ────────────────────────────────────────────
  start: {
    id: 'start',
    message: '¿En qué te podemos ayudar?',
    // Las opciones son los productos de GUIA (spec v4, 03/11/2026): viven en src/data/productos.js,
    // cada uno con el camino que abre. Reemplazan a las cinco del 17/10 (sin «Otra cosa» ni «Tengo otra necesidad»: va al chat).
  },

  // ── CONSULTORÍA TECH ─────────────────────────────────────────────────────
  // An, 04/11/2026: «NO HAGO MÁS WEB Y SISTEMAS. CONSULTORÍA TECH RESERVA HORAS CONMIGO PARA CHARLAR. 20 MINUTOS WEB
  // PARA EL PRIMER CONTACTO SI QUIEREN QUE LO ASESORE SOBRE NUESTROS PRODUCTOS. O SESIONES DE 1 HORA A $99000».
  // Sale el recorrido de web (sitio, nombre, rubro, impresión → tablero web): la elección lleva directo a su página.
  consultoria_result: {
    id: 'consultoria_result',
    servicio: 'Consultoría tech',
    isResult: true,
    cierre: true,
    // Revisión 05/11: las dos formas de reservar están justo debajo, cada una con su botón.
    message: 'Pensemos tu caso juntos.',
    ctas: [
      { label: 'Escribime →', href: `https://wa.me/${WHATSAPP}?text=${encodeURIComponent('Hola Antonela, quiero reservar un tiempo de consultoría. ¿Cuándo podemos?')}` },
    ],
  },

  // ── Agencia ────────────────────────────────────────────────────────────────────────
  // Las preguntas de cada producto se contestan en el chat del contacto, al postularse (An, 05/11: «las preguntas
  // van para el que ya me quiere contactar y leyó sobre el producto»): cada producto entra directo a su `*_result`
  // y su lista de preguntas está en productos.js. Las opciones viajan con el contacto; el `next` de cada una ya no
  // se recorre. El tamaño del equipo sugiere el nivel que viaja con la postulación (recomendar, en planes.js).
  // Para quién es lo dice el switch «Soy: Empresa / Persona» de la home (productos.js). Persona
  // (`fija`) deja `para: 'personal'` (y en Agencia el equipo «Solo yo», que sugiere INICIAL, la base individual de
  // §15e); la página usa `mensajePersonal`. 🟠 Textos a validar.
  ia_equipo: {
    id: 'ia_equipo',
    message: '¿Cuántas personas tiene tu equipo?',
    options: [
      { id: 'solo',      label: 'Solo yo',      next: 'ia_tarea' },
      { id: 'de2a5',     label: 'De 2 a 5',     next: 'ia_tarea' },
      { id: 'de6a20',    label: 'De 6 a 20',    next: 'ia_tarea' },
      { id: 'mas_de_20', label: 'Más de 20',    next: 'ia_tarea' },
    ],
    dataKey: 'equipo',
  },

  // Experimento de lenguaje (An, 03/11): «Coordinación del día a día» y «Seguimiento del equipo»
  // dicen lo mismo y van al mismo lugar A PROPÓSITO. Ids distintos para medir cuál se elige.
  // Excepción declarada a la regla 80/20: no se fusionan.
  ia_tarea: {
    id: 'ia_tarea',
    message: '¿Qué querés eficientizar primero?',
    options: [
      { id: 'mensajes',     label: 'Mensajes',                    next: 'ia_result' },
      { id: 'informes',     label: 'Informes y números',          next: 'ia_result' },
      { id: 'carga',        label: 'Carga de datos',              next: 'ia_result' },
      { id: 'coordinacion', label: 'Coordinación del día a día',  next: 'ia_result' },
      { id: 'seguimiento',  label: 'Seguimiento del equipo',      next: 'ia_result', labelPersonal: 'Seguimiento personal' }, // en «Para mí» es un tracking personal (An, 04/11)
    ],
    dataKey: 'iaTarea',
  },

  ia_result: {
    id: 'ia_result',
    servicio: 'Agencia',
    isResult: true,
    cierre: true,
    // An, 04/11: «ya sabe qué hacer y cómo hacerlo»; «estrategia estable para escalar» queda en la calculadora.
    message: 'Un equipo con espacio para lo importante.\n\nTu agencia ya sabe qué hacer y cómo hacerlo.',
    // Revisión 05/11: el Plan Inicial y sus seis tareas los dice la oferta, y lo que conoce, su primer punto.
    mensajePersonal: 'Tu agencia personal.\n\nLe pedís «armame la semana» y te la trae armada para que la apruebes.',
    ctas: [
      { label: 'Escribime →', href: `https://wa.me/${WHATSAPP}?text=${encodeURIComponent('Hola Antonela, me interesa la Agencia. ¿Charlamos?')}` },
    ],
  },

  // ── TAREAS ───────────────────────────────────────────────────────────────
  // Las seis tareas del kit de INICIAL (lunes, bandeja, cobranzas, presupuesto, reseñas, publicar). Los textos dicen
  // lo que hace cada una (An, 03/11: «los títulos de las tareas deben ser autoexplicativos»), según su SKILL.md del kit.
  hab_q1: {
    id: 'hab_q1',
    message: '¿Con qué tarea empezamos?',
    options: [
      { id: 'lunes',       label: 'Planificar la semana',             next: 'hab_result' },
      { id: 'bandeja',     label: 'Ordenar y responder el mail',      next: 'hab_result' },
      { id: 'cobranzas',   label: 'Seguir las cobranzas',             next: 'hab_result' },
      { id: 'presupuesto', label: 'Armar presupuestos',               next: 'hab_result' },
      { id: 'resenas',     label: 'Responder reseñas de Google',      next: 'hab_result' },
      { id: 'publicar',    label: 'Preparar publicaciones para redes', next: 'hab_result' },
      { id: 'otra',        label: 'Otra',                             next: 'hab_result' },
    ],
    dataKey: 'habilidad',
  },

  hab_result: {
    id: 'hab_result',
    servicio: 'Tareas',
    isResult: true,
    cierre: true,
    message: 'Tareas que salen como las hace tu empresa.',
    // Revisión 05/11: una frase, como en Empresa; cómo se pide y con qué se combina lo dicen la banda y la oferta.
    mensajePersonal: 'Tareas que salen como las hacés vos.',
    ctas: [
      { label: 'Escribime →', href: `https://wa.me/${WHATSAPP}?text=${encodeURIComponent('Hola Antonela, me interesan las Tareas para mi empresa. ¿Charlamos?')}` },
    ],
  },

  // ── AGENTES ────────────────────────────────────────────────────────────
  // An: «no es qué rol», es qué tipo de tareas.
  // Los agentes van por área de expectativas: lo que la empresa espera de cada área es el deseo que se le
  // pide al genio (An, 04/11). La analogía queda en el orden; el copy nombra el área, sin mística.
  // Los ids son los de antes para no cortar la medición.
  agentes_q1: {
    id: 'agentes_q1',
    message: '¿Qué área querés delegar en un agente?',
    options: [
      { id: 'administracion', label: 'Administración',     next: 'agentes_result' },
      { id: 'consultas',      label: 'Atención al cliente', next: 'agentes_result' },
      { id: 'ventas',         label: 'Ventas',             next: 'agentes_result' },
      { id: 'otras',          label: 'Otra',               next: 'agentes_result' },
    ],
    dataKey: 'agenteTareas',
  },

  agentes_result: {
    id: 'agentes_result',
    servicio: 'Agentes',
    isResult: true,
    cierre: true,
    message: 'Un agente por área: le asignás tareas y las ejecuta cuando se lo pidas.',
    // Revisión 05/11: una frase, como en Empresa; el ejemplo de los pagos es la demo de abajo.
    mensajePersonal: 'Un agente para un área de tu trabajo.',
    ctas: [
      { label: 'Escribime →', href: `https://wa.me/${WHATSAPP}?text=${encodeURIComponent('Hola Antonela, me interesan los agentes para mi empresa. ¿Charlamos?')}` },
    ],
  },

  // ── CAPACITACIONES ────────────────────────────────────────────────────────
  // An, 04/11/2026: «A CAPACITACIONES TAMBIÉN: TALLER 1 A 1 DE 1 HORA VIRTUAL, SALE 99000; WORKSHOP GRUPAL CADA 15 DÍAS:
  // AGENDÁ YA VIENDO MI CALENDAR, UNO A LAS 11 AM, OTRO A LAS 15, Y ASÍ VAMOS CAMBIANDO PARA TENER DOS TURNOS. QUÉ HACEMOS:
  // TRAÉS UN PROBLEMA O INQUIETUD Y LA RESOLVEMOS. RESPONDO PREGUNTAS». Sale la pregunta «¿A quién…?»: va directo.
  taller_result: {
    id: 'taller_result',
    servicio: 'Capacitaciones',
    isResult: true,
    cierre: true,
    // Revisión 05/11: los casos que se traen los lista la oferta («Qué podés traer»).
    message: 'Traé tus preguntas sobre IA.\n\nTalleres de preguntas y respuestas.',
    ctas: [
      { label: 'Escribime →', href: `https://wa.me/${WHATSAPP}?text=${encodeURIComponent('Hola Antonela, quiero agendar un taller de IA. ¿Qué turnos hay?')}` },
    ],
  },

  // ── SCAN ──────────────────────────────────────────────────────────────────
  sistema_q1: {
    id: 'sistema_q1',
    message: '¿En qué parte de la operación se pierde más tiempo hoy?',
    options: [
      { id: 'ventas',  label: 'Las ventas o la caja',        next: 'sistema_result' },
      { id: 'pedidos', label: 'Los pedidos o el stock',      next: 'sistema_result' },
      { id: 'quien',   label: 'Quién hace qué y cuándo',     next: 'sistema_result' },
      { id: 'otra',    label: 'Otra cosa',                   next: 'sistema_q1_otra' },
    ],
    dataKey: 'operacion',
  },

  sistema_q1_otra: {
    id: 'sistema_q1_otra',
    message: 'Contanos cuál.',
    input: true,
    placeholder: 'Ej: las ventas de cada sucursal',
    dataKey: 'operacion',
    next: 'sistema_result',
  },

  sistema_result: {
    id: 'sistema_result',
    servicio: 'Scan',
    isResult: true,
    cierre: true,
    message: 'Entender cómo trabaja tu empresa.\n\nMuchas veces el sistema que falta ya existe, escondido en las planillas que usás.',
    ctas: [
      { label: 'Escribime →', href: `https://wa.me/${WHATSAPP}?text=${encodeURIComponent('Hola Antonela, me interesa el Scan de mi empresa. ¿Charlamos?')}` },
    ],
  },
};

// El id de la opción que la persona eligió en un nodo (lo recolectado guarda el texto de la opción).
// Las reglas (planes.js, valor.js) leen ids: cambiar un texto no las rompe. Sin respuesta no hay opción (desde el
// 05/11 se entra a la página sin contestar, y una opción sin `labelPersonal` coincidía con la respuesta vacía).
export const idDeOpcion = (nodoId, label) => (label ? FLOWS[nodoId]?.options?.find(o => o.label === label || o.labelPersonal === label)?.id || null : null);
